import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const dashboardRoute: InvariantJiraRoute = {
	name: 'dashboard',
	path: '/secure/Dashboard.jspa',
};
